<template>
    <div class="black-text">
        <div id="message-search" class="card border-0">
            <div class="row justify-content-center ">
                <div class="col-md-12 pt-3 pb-3">
                    <a
                        @click.prevent="toggleShowSearch()"
                        class="d-flex justify-content-between align-content-center font-weight-bold px-3 sb-block-title"
                        style="cursor: pointer;"
                        href="#"
                    >
                        Message Search
                        <i class="pt-1 fa" :class="{'fa-angle-double-up': showSearch, 'fa-angle-double-down': !showSearch}"></i>
                    </a>
                </div>
            </div>

            <div v-if="showSearch">
                <div class="row justify-content-center pl-4 pr-4 pb-2 search-messages-wrapper">
                    <div class="col-md-6">
                        <div class="form-group row mb-0">
                            <label for="search-message-content" class="col-sm-12 col-form-label font-weight-normal small-bottom-padding">Search Messages</label>
                            <div class="col-sm-12">
                                <input type="text" v-model="searchFormData.content" class="form-control" id="search-message-content" name="search-message-content" autocomplete="off">
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <label for="search-message-to" class="col-sm-12 col-form-label font-weight-normal small-bottom-padding">To</label>
                            <div class="col-sm-12">
                                <input type="text" v-model="searchFormData.to" @input="clearOtherInput('to')" required class="form-control" id="search-message-to" name="search-message-to">
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <label title="Date Sent" for="search-message-date-sent" class="col-sm-12 col-form-label font-weight-normal small-bottom-padding">Date Sent</label>
                            <div class="col-sm-12">
                                <!--                            <input id="search-message-date-sent" class="form-control" name="search-message-date-sent" autocomplete="off">-->
                                <date-picker :input-attr="{id: 'search-message-date-sent', name: 'search-message-date-sent'}" v-model="searchFormData.dateSent" valueType="format" format="MM/DD/YYYY" lang="en"></date-picker>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group row" style="margin-bottom:12px">
                            <label for="search-message-status" class="col-sm-12 col-form-label font-weight-normal small-bottom-padding">Status</label>
                            <div class="col-sm-12 align-items-baseline">
                                <div class="form-check form-check-inline col-sm-3">
                                    <input type="checkbox" class="form-check-input" id="search-message-status-sent" v-model="searchFormData.status" value="sent">
                                    <label class="form-check-label font-weight-normal" for="search-message-status-sent">Sent</label>
                                </div>
                                <div class="form-check form-check-inline col-sm-3">
                                    <input type="checkbox" class="form-check-input" id="search-message-status-read" v-model="searchFormData.status" value="read">
                                    <label class="form-check-label font-weight-normal" for="search-message-status-read">Read</label>
                                </div>
                                <div class="form-check form-check-inline col-sm-3">
                                    <input type="checkbox" class="form-check-input" id="search-message-status-unread" v-model="searchFormData.status" value="unread">
                                    <label class="form-check-label font-weight-normal" for="search-message-status-unread">Unread</label>
                                </div>
                                <!--                            <div class="form-check form-check-inline">-->
                                <!--                                <input type="checkbox" class="form-check-input" id="search-message-status-archived" v-model="searchFormData.status" value="archived">-->
                                <!--                                <label class="form-check-label font-weight-normal" for="search-message-status-archived">Archived</label>-->
                                <!--                            </div>-->
                            </div>
                        </div>

                        <div class="form-group row mb-0">
                            <label for="search-message-from" style="padding-bottom:6px;" class="col-sm-12 col-form-label font-weight-normal small-bottom-padding">From</label>
                            <div class="col-sm-12">
                                <input type="text" class="form-control" v-model="searchFormData.from" @input="clearOtherInput('from')" name="search-message-from" id="search-message-from" autocomplete="on">
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <label title="Received On" for="search-message-date-received" class="col-sm-12 col-form-label font-weight-normal small-bottom-padding">Received On</label>
                            <div class="col-sm-12">
                                <date-picker :input-attr="{id: 'search-message-date-received', name: 'search-message-date-received'}" v-model="searchFormData.dateReceived" valueType="format" format="MM/DD/YYYY" lang="en"></date-picker>
                            </div>
                        </div>
                    </div>


                </div>

                <div class="form-group row m-2 text-right">
                    <div class="col-sm-12 text-right">
                        <button type="button" class="btn green-button" @click="renderList()">Search</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="message-inbox" class="card border-0 mt-4">
            <div class="row justify-content-center ">
                <div class="col-md-12 pt-3">
                    <p class="font-weight-bold pl-3 mb-3 sb-block-title">Message Inbox</p>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-12" id="user-form">
                    <div class="col-md-12" id="user-form">
                        <div class="row message-center-inbox-header-row">
                            <div class="col-md-3 font-weight-bold">Sender</div>
                            <div class="col-md-4 font-weight-bold">Subject</div>
                            <div class="col-md-3 font-weight-bold">Received</div>
                            <div class="col-md-2 font-weight-bold text-right">Action</div>
                        </div>
                        <div v-for="(message, index) in paginatedMessages" :key="index" class="row message-center-inbox-row vertically-align-text" :class="{'font-weight-bold': message.status_wellth === 'unread'}">
                            <div class="col-md-3 vertically-align-content limit-line-height">{{ message.user_display_name }}</div>
                            <div class="col-md-4 vertically-align-content limit-line-height">
                                <span class="fas color-gray" :class="getSentOrReceivedArrow(message.status_wellth)">&nbsp;</span>{{ message.thread.subject }}
                            </div>
                            <div class="col-md-3 vertically-align-content" style="white-space: nowrap;">
                                {{ convertDateFromUTCToLocal(message.created_at) }}
                            </div>
                            <div class="col-md-2 vertically-align-content justify-right">
                                <a class="message-view-action"
                                   style="font: normal normal bold 14px/22px Nunito;"
                                   @click="showMessageModal(message)"
                                   tabindex="0"
                                   role="link"
                                   :aria-label="'View Message ' + (index + 1)">
                                    <i class="fa fa-eye" style="font-size:12px"></i> View
                                </a>
                            </div>
                        </div>
                        <div v-if="paginatedMessages.length === 0" class="row message-center-inbox-row">
                            <div class="justify-content-center col-md-12 vertically-align-content limit-line-height py-2"
                                 style="font-style:italic">
                                No Messages Available
                            </div>
                        </div>

                        <div class="overflow-auto pt-3">
                            <b-pagination-nav
                                v-model="currentPage"
                                :total-rows="countOfMessages"
                                :per-page="perPage"
                                class="justify-content-end"
                            ></b-pagination-nav>

                            <p class="mt-3 text-right">Number of Messages: {{ countOfMessages }}</p>
                            <p class="mt-3 text-right">Current Page: {{ currentPage }}</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showMessage">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title"><span>View Message</span></h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" @click="closeMessageModal()">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body" id="contact-form" style="color: #000000;">

                                    <div class="font-weight-bold">
                                        <span class="fas color-gray" :class="getSentOrReceivedArrow(selectedMessage.status_wellth)"></span>
                                        From: <span class="font-weight-normal">{{ selectedMessage.user_display_name }}</span>
                                    </div>
                                    <div class="shift-right">
                                        <div
                                            class="font-weight-bold">Received: <span class="font-weight-normal">{{ selectedMessage.created_at }}</span>
                                        </div>
                                        <div
                                            class="font-weight-bold">Subject: <span class="font-weight-normal">{{ selectedMessage.thread.subject }}</span>
                                        </div>
                                        <div class="pt-3">{{ selectedMessage.body }}</div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn green-button" @click="showReplyModal()">Reply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="showReply">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title"><span>Send Reply</span></h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" @click="closeReplyModal()">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body" id="reply-form">
                                    <div class="py-2 px-2 alert-danger override-p-styling fs-12" v-html="termsAndConditions"></div>
                                    <div class="font-weight-bold pb-3 pt-2">
                                        <label for="reply-message-content" class="col-form-label font-weight-bold">Subject: {{ selectedMessage.thread.subject }}</label>
                                    </div>
                                    <div class="form-group">

                                        <div class="row">
                                            <div class="col-md-6">
                                                <label for="reply-message-content" class="col-form-label" style="font-weight:400;">Message <span class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="reply-message-content" class="col-form-label message-center-modal-gray" style="font-weight: 400;">{{ replyToMessageFormData.reply.length }}/3000</label>
                                            </div>
                                        </div>
                                        <textarea
                                            v-model="replyToMessageFormData.reply"
                                            class="form-control large-text-box"
                                            id="reply-message-content"
                                            name="reply-message-content"
                                            autocomplete="off"
                                            style="resize:none"
                                            maxlength="3000"
                                        >
                                        </textarea>
                                    </div>
                                    <div class="text-right">
                                        <button type="button"
                                                class="btn green-button"
                                                @click="replyToMessage()"
                                                :disabled="messages.user_blocked"
                                                :title="blockedTooltip"
                                                :style="{ cursor: messages.user_blocked ? 'not-allowed' : 'pointer' }"
                                        >Send</button>
                                    </div>
                                </div>

                                <div class="justify-content-start">
                                    <div class="modal-body scrollable-messages">
                                        <div v-for="message in threadMessages" class="row message-center-reply-thread-row pb-3">
                                            <div class="font-weight-bold col-12 py-2">
                                                <span class="fas color-gray" :class="getSentOrReceivedArrow(message.status_wellth)"></span>
                                                {{ message.user_display_name + ' - ' + convertDateFromUTCToLocal(message.created_at)}}
                                            </div>
                                            <div class="shift-right">
                                                <div class="col-12">{{ message.body }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-3 text-right">
                                    <button type="button" class="btn btn-secondary" @click="closeReplyModal()">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="showNurse">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title message-center-modal-gray"><span>Contact Nurse</span></h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" @click="closeContactNurseModal()">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body" id="nurse-contact-form">
                                    <div class="py-2 px-2 alert-danger override-p-styling fs-12" v-html="termsAndConditions"></div>
                                    <div class="form-group">
                                        <label for="contact-nurse-subject" class="col-form-label message-center-modal-gray pt-3" style="font-weight:400;">Subject <span class="text-danger">*</span></label>
                                        <input
                                            v-model="contactNurseFormData.subject"
                                            type="text" class="form-control"
                                            id="contact-nurse-subject"
                                            name="contact-nurse-subject"
                                            autocomplete="off"
                                        >
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label for="contact-nurse-message" class="col-form-label message-center-modal-gray" style="font-weight: 400;">Message <span class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label class="col-form-label message-center-modal-gray" style="font-weight: 400;">{{ contactNurseFormData.body.length }}/3000</label>
                                            </div>
                                        </div>
                                        <textarea
                                            v-model="contactNurseFormData.body"
                                            type="text"
                                            class="form-control large-text-box"
                                            id="contact-nurse-message"
                                            name="contact-nurse-message"
                                            autocomplete="off"
                                            maxlength="3000"
                                            style="resize: none;"
                                        >
                                        </textarea>
                                    </div>
                                    <div class="text-right">
                                        <button type="button"
                                                class="btn green-button"
                                                @click="contactNurse()"
                                                :disabled="messages.user_blocked"
                                                :title="blockedTooltip"
                                                :style="{ cursor: messages.user_blocked ? 'not-allowed' : 'pointer' }"
                                        >Send</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

    </div>
</template>


<script>
import { BPagination } from 'bootstrap-vue'
Vue.component('b-pagination-nav', BPagination)
export default {
    name: "SbMessageCenter",
    props:['user', 'page'],
    mounted() {
        const vm = this;
        this.getMessagingGroupConfig();
        $(document).on('click', '#contact-nurse', function() {
            vm.showContactNurseModal();
        });
        this.loadPreviousSearch();
        this.renderList();
    },
    computed: {
        countOfMessages() {
            return this.messages.messages.length;
        },
        paginatedMessages() {
            const startIndex = (this.currentPage - 1) * this.perPage;
            const endIndex = this.currentPage * this.perPage;
            return this.messages.messages.slice(startIndex, endIndex);
        },
        blockedTooltip() {
            if (this.messages.user_blocked) {
                return 'User is blocked.'; // Set the tooltip text when the button is disabled
            } else {
                return ''; // Set an empty tooltip text when the button is enabled
            }
        },
    },
    created: function() {

    },
    data(){
        return {
            perPage: 10,
            currentPage: 1,
            groupConfigRoute: '/api/messaging/group-config/',
            getMessagesRoute: '/api/messaging/messages/',
            contactNurseRoute: '/api/messaging/contact-nurse/',
            replyToMessageRoute: '/api/messaging/reply-to-message/',
            updateMessageStatusRoute: '/api/messaging/update-message-status/',
            getAlertCountRoute: '/api/messaging/get-alert-count/',
            messages: {
                'messages': [],
                'user_blocked': true
            },
            threadMessages: [],
            showMessage: false,
            showReply: false,
            showNurse: false,
            showSearch: false,
            termsAndConditions: '',
            errorResponse: '',
            selectedMessage: {
                'thread_uuid': ''
            },
            searchFormData: {
                orderBy: 'created_at',
                order: 'asc',
                perPage: 10,
                content: '',
                to: '' ,
                from: '',
                dateSent: '',
                dateReceived: '',
                status: []
            },
            contactNurseFormData: {
                subject: '',
                body: ''
            },
            replyToMessageFormData: {
                'reply' : '',
                'thread_uuid': ''
            },
            updateMessageStatusFormData: {
                'status' : '',
                'uuid' : ''
            },
        }
    },

    watch: {
        selectedMessage: {
            handler(newSelectedMessage) {
                this.replyToMessageFormData.thread_uuid = newSelectedMessage.thread_uuid;
                this.replyToMessageFormData.reply = '';
            }
        }
    },

    methods:{
        showMessageModal(message) {
            this.selectedMessage = message;
            // this.showMessage = true;
            if(message.status_wellth === 'unread') {
                this.updateMessageStatusFormData.status = 'read';
                this.updateMessageStatusFormData.uuid = message.uuid;
                this.updateMessageStatus();
            }
            this.showReplyModal();
        },

        toggleShowSearch() {
            this.showSearch = ! this.showSearch;
        },

        closeMessageModal() {
            this.showMessage = false;
        },

        showReplyModal() {
            this.showMessage = false;
            this.updateThreadMessages();
            this.showReply = true;
        },

        updateThreadMessages() {
            this.threadMessages = this.messages.messages.filter(
                message => message.thread_uuid === this.selectedMessage.thread_uuid
            )
        },

        clearOtherInput(inputField) {
            // Clear the opposite input field when typing starts in the current input field
            if (inputField === 'to') {
                this.searchFormData.from = '';
            } else if (inputField === 'from') {
                this.searchFormData.to = '';
            }
        },

        closeReplyModal() {
            this.showReply = false;
        },

        showContactNurseModal() {
            this.showNurse = true;
        },

        closeContactNurseModal() {
            this.showNurse = false;
            this.contactNurseFormData.body = '';
            this.contactNurseFormData.message = '';
        },

        updateMessageStatus() {
            this.$http.get(this.updateMessageStatusRoute, {params : this.updateMessageStatusFormData}).then(function(response) {
                this.renderList();
            }, (response) => {
                this.errorResponse = response;
            })
        },

        getMessagingGroupConfig(){
            this.$http.get(this.groupConfigRoute + this.user.group_id)
                .then(function(response) {
                    this.termsAndConditions = response.data.terms_and_conditions;
                }, (response) => {
                    this.errorResponse = response;
                })
        },

        contactNurse(){
            if(this.contactNurseFormData.subject === '' || this.contactNurseFormData.body === '') {
                this.$notify({
                    type: 'error',
                    title: 'Error',
                    text: 'Please fill out both Subject and Message.'
                })

                return;
            }

            this.$http.get(this.contactNurseRoute, {params : this.contactNurseFormData}).then(function(response) {
                this.$notify({
                    type: 'success',
                    title: 'Success',
                    text: 'Message sent.'
                });
                this.renderList();
                this.closeContactNurseModal();
            }, (response) => {
                this.errorResponse = response;
            })
        },

        replyToMessage() {
            if(this.replyToMessageFormData.reply === '') {
                this.$notify({
                    type: 'error',
                    title: 'Error',
                    text: 'Please fill out the Message field.'
                })

                return;
            }

            this.$http.get(this.replyToMessageRoute, {params : this.replyToMessageFormData}).then(function(response) {
                this.$notify({
                    type: 'success',
                    title: 'Success',
                    text: 'Reply Sent.'
                });
                this.renderList();
                this.replyToMessageFormData.reply = '';
                this.showReply = false;
            }, (response) => {
                this.errorResponse = response;
            })
        },

        renderList() {
            this.$http.get(this.getMessagesRoute, {params : this.searchFormData}).then(function (response) {
                this.messages = response.body;
                this.updateThreadMessages();
            }, (response) => {
                this.errorResponse = response;
            });
            this.$http.get(this.getAlertCountRoute).then(function (response) {
                let alertCount = response.body.total;
                let alertCountElement = $('#alert_count');
                alertCountElement.html(alertCount);
            }, (response) => {
                this.errorResponse = response;
            });
            this.saveSearchToLocalStorage();
        },

        getSentOrReceivedArrow(status_wellth) {
            if(status_wellth === 'sent') {
                return 'fa-arrow-up';
            }
            return 'fa-arrow-down';
        },

        saveSearchToLocalStorage() {
            localStorage.setItem('searchFormDataTo', JSON.stringify(this.searchFormData.to));
            localStorage.setItem('searchFormDataFrom', JSON.stringify(this.searchFormData.from));
            localStorage.setItem('searchFormDataContent', JSON.stringify(this.searchFormData.content));
            localStorage.setItem('searchFormDataDateSent', JSON.stringify(this.searchFormData.dateSent));
            localStorage.setItem('searchFormDataDateReceived', JSON.stringify(this.searchFormData.dateReceived));
            if(this.searchFormData.status) {
                localStorage.setItem('searchFormDataStatus', JSON.stringify(this.searchFormData.status));
            }
        },

        loadPreviousSearch() {
            this.searchFormData.to = JSON.parse(localStorage.getItem('searchFormDataTo'));
            this.searchFormData.from = JSON.parse(localStorage.getItem('searchFormDataFrom'));
            this.searchFormData.content = JSON.parse(localStorage.getItem('searchFormDataContent'));
            this.searchFormData.dateSent = JSON.parse(localStorage.getItem('searchFormDataDateSent'));
            this.searchFormData.dateReceived = JSON.parse(localStorage.getItem('searchFormDataDateReceived'));
            if(JSON.parse(localStorage.getItem('searchFormDataStatus'))) {
                this.searchFormData.status = JSON.parse(localStorage.getItem('searchFormDataStatus'));
            }
        },
        convertDateFromUTCToLocal(dateStr) {
            const parts = dateStr.split(', ');
            const datePart = parts[0];
            const timePart = parts[1];

            const dateParts = datePart.split('/');
            const timeParts = timePart.split(':');
            const amPm = timeParts[2].split(' ')[1];

            let hours24 = parseInt(timeParts[0], 10);
            if (amPm === 'PM' && hours24 < 12) {
                hours24 += 12;
            } else if (amPm === 'AM' && hours24 === 12) {
                hours24 = 0;
            }

            const hours24Str = hours24.toString().padStart(2, '0');
            const isoString = `${dateParts[2]}-${dateParts[0].padStart(2, '0')}-${dateParts[1]
                .padStart(2, '0')}T${hours24Str}:${timeParts[1]}:${timeParts[2].split(' ')[0]}Z`;
            const dateUtc = new Date(isoString);

            return dateUtc.toLocaleString();
        }
    }

}
</script>

<style>
    .vue-notification-group {
        z-index: 9999;
    }

    .black-text {
        color:#000000;
    }

    .modal-lg, .modal-xl {
        max-width: 700px;
        color: #3F5058 !important;
    }

    .modal-body {
        color: #3F5058 !important;
    }

    .large-text-box {
        height: 85px !important;
    }

    .col-form-label {
        padding-bottom:0;
    }

    .small-bottom-padding {
        padding-bottom:7px;
    }
    .alert-danger {
        background: #F8D6D5;
    }

</style>
